<template>
	<div class="ReChatWrapper" :class="{'isSwitch':this.bIsSwitch}">
        <div class="row">
            <div class="col-md col-xl-4 chatSidebar mb-3"> <!--:class="{'active':bIsActiveLeft}"-->
                <ReChatSidebar/>
            </div>
            <div class="col chatMain"> <!--:class="{'active':!bIsActiveLeft}"-->
                <ReChatMain :chatIsHidden="false"/>
            </div>
        </div>
	</div>
</template>

<script>
import ReChatSidebar from "src/our_components/ReChatSidebar.vue";
import ReChatMain from "src/our_components/ReChatMain.vue";

export default {
    name: 'ReChatWrapper',
    components: {
        ReChatSidebar,
		ReChatMain,
    },
    props: {
        counter: String,
        findId: {
            type: String,
            default: '',
        },
        bIsActiveLeft: {
            type: Boolean,
            default: true
        },
        bIsSwitch: {
            type: Boolean,
            default: false
		},
    },
    data () {
        return {
            ver: 1,
        }
    },
    computed: {

    },
    methods: {

    },
}
</script>

<style scoped>
.chatMain  {border-left: 1px solid #01b0e0;}
.ReChatWrapper{display: block;}
@media (max-width: 768px) {
.chatMain  {border-left: 1px solid transparent;}
.ReChatWrapper{display: block;}
/*
.ReChatWrapper.isSwitch > * {display: none;}
.ReChatWrapper.isSwitch .chatSidebar.active,.ReChatWrapper.isSwitch .chatMain.active{display: flex;}
*/
}

</style>
